import Http from '../utils/Http';
import { ConfigResponse } from './types';

export default class ConfigApi {
    static getConfig: () => Promise<ConfigResponse> = () => {
        return Http.get<ConfigResponse>('/config').then((r) => r.data);
    };
}
